// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-20582191] #progress .v-progress-linear__background{background-color:var(--33dc4332)!important}[data-v-20582191] #progress .v-progress-linear__determinate{background-color:var(--33dc4332)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
